import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageNotFoundComponent } from './page-not-found.component';
import { TranslationModule } from '../shared/translation/translation.module';

@NgModule({
  imports: [
    CommonModule,
    TranslationModule
  ],
  declarations: [PageNotFoundComponent]
})
export class PageNotFoundModule { }
